<template>
  <router-view />
  <CookieBanner />
</template>
<script>
import CookieBanner from './components/CookieConsent/CookieBanner.vue';

export default {
  name: 'App',
  components: {
    CookieBanner
  }
}
</script>

<style>
/* Import a modern sans-serif font */
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@200;400;500;600;700&display=swap');

html, body, #app {
  margin: 0;
  padding: 0;
  font-family: 'Poppins', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 400;
  color: #2c3e50;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Headings */
h1, h2, h3, h4, h5, h6 {
  font-family: 'Poppins', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 500; /* Medium for headings */
  margin: 0;
  line-height: 1.2;
  color: #2c3e50;
}

/* Paragraphs */
p {
  font-family: 'Poppins', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-weight: 400;
  line-height: 1.6;
  color: #333;
  margin: 0 0 1rem 0;
}

/* Links */
a {
  font-family: 'Poppins', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: #2c3e50;
  text-decoration: none;
}

/* Buttons and inputs */
button, input, textarea, select {
  font-family: 'Poppins', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
</style>
